import React, { useEffect, useState } from 'react';
import { Toast, Text } from '@lana-ui/common';
import LoadingSpinner from '../../Helpers/LoadingSpinner';
import TipoPropiedad from '../../Components/Features/Domicilio/TipoPropiedad';
import FormNormalizarDomicilio from '../../Components/Features/Domicilio/FormNormalizarDomicilio';
import PhonesBanner from '../../Components/Common/banner/PhonesBanner';
import Countries from '../../Components/Features/Domicilio/Countries';
import TextLogin from '../../Components/Common/login/src/textLogin/TextLogin.jsx';
import '@styles/Pages/ingresarDomicilio.scss';
import CompletarDomicilio from './CompletarDomicilio';
import { PageViewTrackAndLogData } from '../../Config/TrackAndLogData';
import { Button } from '@lana-ui/login';
import ToastDomicilioExistente from '../../Components/Features/Domicilio/ToastDomicilioExistente';

const IngresarDomicilio = ({ send, state }) => {
    const [tipoPropiedadSelected, setTipoPropiedadSelected] = useState('casa');
    const [seleccionCountry, setSeleccion] = useState();
    const [isLoadingNormalizar, setIsLoadingNormalizar] = useState();
    const [errorNormalizar, setErrorNormalizar] = useState();
    const [isLastStep, setIsLastStep] = useState(false);
    const [domicilioElegido, setDomicilioElegido] = useState();
    const [isLoadingCompletar, setIsLoadingCompletar] = useState();
    const [showToastPagoConfirmado, setShowToastPagoConfirmado] = useState(true);
    const [toastDomicilioExistente, setToastDomicilioExistente] = useState();
    const agregandoDomicilio = state.context.agregarDomicilio;

    useEffect(() => {
        PageViewTrackAndLogData('formulario_domicilio', state.context.planCampania.descripcion);
    }, []);

    return (
        <>
                {showToastPagoConfirmado && (
                    <Toast
                        status={'success'}
                        title="¡Listo!"
                        type={'toast'}
                        value={showToastPagoConfirmado}
                        closeAuto={true}
                        close
                        className="--roboto"
                        changeValue={() => {
                            return setShowToastPagoConfirmado(false);
                        }}
                    >
                        ¡Tu pago se realizó con éxito!
                    </Toast>
                )}
            <LoadingSpinner isLoading={isLoadingNormalizar || isLoadingCompletar}>

                <TextLogin
                    title={
                        <>
                            ¡Estás a un solo paso de tener tu credencial
                            <span className="ln"> Club LA NACION!</span>
                            <br />
                            ¿Dónde la querés recibir?{' '}
                        </>
                    }
                >
                    <Text as="p" size="4xs">
                        Sólo pueden ingresarse domicilios de Argentina.
                    </Text>
                </TextLogin>
                <div className="ingresar-domicilio-form">
                    {isLastStep ? (
                        <CompletarDomicilio
                            tipoPropiedadSelected={tipoPropiedadSelected}
                            seleccionCountry={seleccionCountry}
                            domicilioElegido={domicilioElegido}
                            setIsLastStep={setIsLastStep}
                            setTipoPropiedadSelected={setTipoPropiedadSelected}
                            setSeleccion={setSeleccion}
                            setIsLoadingCompletar={setIsLoadingCompletar}
                            send={send}
                            state={state}
                            errorNormalizacion={errorNormalizar}
                            setErrorNormalizar={setErrorNormalizar}
                            setToastDomicilioExistente={setToastDomicilioExistente}
                        />
                    ) : (
                        <>
                            {toastDomicilioExistente && <ToastDomicilioExistente />}
                            <TipoPropiedad setTipoPropiedadSelected={setTipoPropiedadSelected} tipoPropiedadSelected={tipoPropiedadSelected} setSeleccionCountry={setSeleccion} />
                            {tipoPropiedadSelected === 'country' && <Countries setSeleccion={setSeleccion} setIsLastStep={setIsLastStep} />}
                            <FormNormalizarDomicilio
                                tipoPropiedadSelected={tipoPropiedadSelected}
                                seleccionCountry={seleccionCountry}
                                setErrorNormalizar={setErrorNormalizar}
                                setIsLoadingNormalizar={setIsLoadingNormalizar}
                                setIsLastStep={setIsLastStep}
                                setDomicilioElegido={setDomicilioElegido}
                            />
                        </>
                    )}
                    {agregandoDomicilio && !isLastStep && (
                        <>
                            <Button className="--border-blue" onClick={() => send('VOLVER')}>
                                VOLVER A MIS DOMICILIOS
                            </Button>
                            <br />
                        </>
                    )}
                    <PhonesBanner notSuscribe />
                </div>
            </LoadingSpinner>
        </>
    );
};

export default IngresarDomicilio;
